import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AppRequestContextService } from '../../../app-request-context.service';

export const categoryExistsGuardFn: CanActivateFn = (routeSnapshot: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const appRequestContext = inject(AppRequestContextService);

  const { categoryId } = routeSnapshot.params;

  const category = appRequestContext.allCategories().find(c => {
    return categoryId === c.id || categoryId === c.slug;
  });

  if (!category || !category.active) {
    return router.createUrlTree(['/']);
  }
  return true;
};
